import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setShowBanner(true), 2000); // Show after 2 seconds
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div data-testid="cookie-consent" className="print:hidden fixed bottom-0 left-0 right-0 z-[90] bg-slate-900/95 backdrop-blur-lg border-t border-amber-500/30 p-6 animate-slide-up-fade shadow-2xl">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-start gap-4 flex-1">
          <svg className="w-6 h-6 text-amber-400 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
            <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
          </svg>
          <div>
            <p className="text-white text-sm md:text-base font-medium mb-1">
              🍪 Käytämme evästeitä parantaaksemme käyttökokemustasi
            </p>
            <p className="text-gray-300 text-xs md:text-sm">
              Käytämme evästeitä varmistaaksemme parhaan mahdollisen käyttökokemuksen verkkosivuillamme. Jatkamalla sivuston käyttöä hyväksyt evästeiden käytön.
            </p>
          </div>
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={declineCookies}
            className="px-6 py-2.5 border border-gray-500 text-white rounded-lg hover:bg-gray-700 transition-all duration-300 text-sm font-medium"
          >
            Hylkää
          </button>
          <button
            onClick={acceptCookies}
            className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg hover:from-amber-600 hover:to-orange-600 transition-all duration-300 text-sm font-medium shadow-lg hover:shadow-xl"
          >
            Hyväksy evästeet
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
